import { Underscore } from "./underscore";
import { AvailabilityCalendarEvent, UnderScoreColor } from "./utils";

type Props = {
  calendarEvents: AvailabilityCalendarEvent[];
};

export function UnderscoreWrapper(props: Props) {
  if (props.calendarEvents.length === 0) {
    return null;
  }

  const colorExists = (c: UnderScoreColor) => {
    return props.calendarEvents.some((d) => d.color === c);
  };

  return (
    <span style={style}>
      {colorExists(UnderScoreColor.Primary) && (
        <Underscore color={UnderScoreColor.Primary} />
      )}
      {colorExists(UnderScoreColor.Blue) && <Underscore color={UnderScoreColor.Blue} />}
      {colorExists(UnderScoreColor.DashedGreen) && (
        <Underscore color={UnderScoreColor.DashedGreen} />
      )}
    </span>
  );
}

const style = {
  position: "absolute",
  bottom: "-8px",
  height: "16px",
  left: "0",
  right: "0",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexDirection: "column",
  zIndex: 1,
  padding: "0 8px"
} as const;
